module.exports = __webpack_public_path__ + "img/70f1.8fd48062.jpg";